/**
 * Rentals list glue (templates/propmgmt/rentals/list/).
 *
 * - rentalsListRowQs(): the tab + market + filters on screen, read off
 *   #list-results-wrapper's data-row-qs. The next-action and tags panels send it as
 *   `row_qs` (hx-vals) so a saved row re-renders for the scope the user is looking at.
 * - [data-fill-field="name"] chips: copy data-fill-value into the same form's input of
 *   that name (the previous-action-status presets).
 */

window.rentalsListRowQs = function () {
    var wrapper = document.getElementById('list-results-wrapper');
    return (wrapper && wrapper.getAttribute('data-row-qs')) || '';
};

document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var chip = e.target.closest('[data-fill-field]');
    if (!chip) return;
    var form = chip.closest('form');
    if (!form) return;
    var input = form.querySelector('[name="' + chip.getAttribute('data-fill-field') + '"]');
    if (!input) return;
    input.value = chip.getAttribute('data-fill-value') || '';
    chip.parentNode.querySelectorAll('[data-fill-field]').forEach(function (c) {
        c.classList.toggle('chip-primary', c === chip);
        c.classList.toggle('chip-muted', c !== chip);
    });
});
